import { Skeleton } from '@mui/material';
import { TrendChart } from './TrendChart';
import { LoadableTrendEntry } from '../CampaignDataGrid/columns';

type TrendChartTempProps = {
  trendEntry?: LoadableTrendEntry;
  height: string;
};

export const TrendChartContainer = (props: TrendChartTempProps) => {
  if (!props.trendEntry) return null;

  if (props.trendEntry.status === 'loading') {
    return <Skeleton animation="wave" sx={{ width: '100%', height: '100%' }} />;
  }

  return props.trendEntry.data.length > 0 ? (
    <TrendChart values={props.trendEntry.data} height={props.height} />
  ) : null;
};
